import { Component, OnDestroy, OnInit } from '@angular/core';
import { DatafieldAttributes, DatasheetService } from 'src/app/services/datasheet/datasheet.service';
import { DatepickerService } from 'src/app/services/utils/date-picker/datepicker.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { IDatafieldComponent } from '../datafield.interface';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DatafieldsEnum } from '../datafield.enum';
import { Datafield } from 'src/app/models/database/datafield.model';
import { DatasheetBuilderService } from 'src/app/services/datasheet-builder/datasheet-builder.service';

@Component({
  selector: 'app-datafield-date',
  templateUrl: './datafield-date.component.html',
  styleUrls: ['./datafield-date.component.scss']
})
export class DatafieldDateComponent implements OnInit, OnDestroy, IDatafieldComponent {

  formControl: FormControl = this.formBuilder.control(this.datepickerService.todayInStringForDatepicker, [Validators.required])
  formControlSubmitted: boolean = false
  label: string
  session: string
  value: any
  datafield: Datafield
  subscriptionManager: Subscription = new Subscription()

  constructor(
    private datasheetService: DatasheetService,
    private datepickerService: DatepickerService,
    private formBuilder: FormBuilder,
    public datasheetBuilderService: DatasheetBuilderService
  ) { }

  ngOnInit(): void {
    if (this.value) {
      this.formControl.setValue(this.datepickerService.convertDateFromDatabaseToDatepickerStringFormat(this.value))
      this.formControl.disable()
    }
    this.subscriptionManager.add(this.datasheetService.datafieldValidationSubject
      .pipe(tap(() => {
        this.formControlSubmitted = true
        if (this.formControl.invalid) {
          this.datasheetService.everythingIsValid = false
          return
        }
        this.formControlSubmitted = false
      })).subscribe())
    this.subscriptionManager.add(this.datasheetService.datasheetObjectBuilder$.pipe(
      tap(() => {
        const datafieldAttributes: DatafieldAttributes =
          new DatafieldAttributes(DatafieldsEnum.DATE, this.label, this.formControl.value)
        this.datasheetService.buildDatasheetObject(this.session, datafieldAttributes)
      })
    ).subscribe())
  }

  ngOnDestroy(): void {
    this.subscriptionManager.unsubscribe()
  }
}
